const ALT_CARD_WIDTH = 337

module.exports = { ALT_CARD_WIDTH }
